export default __webpack_public_path__ + "static/media/membrana-consejo-1.2cd5d7dd.JPG";